import styled from "styled-components";

import { fontSizes, lineHeights } from "../../../shared/styles/typography";
import { pageRoot } from "../../../styles/pageRoot";

export const Container = styled.div`
  ${pageRoot}
  background-color: #f5f6fa;
`;

export const Main = styled.main`
  width: 90%;
  max-width: 1000px;
  margin: 4rem auto;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
`;

export const TranslatorBox = styled.div`
  display: grid;
  grid-template-columns: 1fr 2px 1fr;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(82, 54, 152, 0.05);
  border: 1.5px solid #f0eefa;
  overflow: hidden;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    .mobile-hide {
      display: none;
    }
  }
`;

export const InputSection = styled.div`
  padding: 3.2rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  h3 {
    font-size: ${fontSizes.base}px;
    line-height: ${lineHeights.base}px;
    font-weight: var(--font-weight-bold);
    color: #1a1340;
    margin: 0;
  }
`;

export const OutputSection = styled.div`
  padding: 3.2rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  background: #fafbff;

  h3 {
    font-size: ${fontSizes.base}px;
    line-height: ${lineHeights.base}px;
    font-weight: var(--font-weight-bold);
    color: #1a1340;
    margin: 0;
  }

  .glosa-result {
    flex: 1;
    min-height: 15rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 12px;
    border: 1.5px dashed #e2e8f0;
    padding: 2.4rem;
    text-align: center;

    .glosa-text {
      font-size: ${fontSizes.xl}px;
      line-height: ${lineHeights.xl}px;
      font-weight: var(--font-weight-bold);
      color: var(--color-primary);
      text-transform: uppercase;
      letter-spacing: 0.2rem;
    }

    .placeholder {
      color: #94a3b8;
      font-size: ${fontSizes.sm}px;
      line-height: ${lineHeights.sm}px;
    }

    .loading-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.2rem;
      color: var(--color-primary);
    }
  }
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 2.4rem;
  border: 1px solid #f0eefa;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ResultBox = styled.div`
  background: #f8faff;
  padding: 2rem;
  border-radius: 12px;
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const TipCard = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 2rem;
  border: 1px solid #f0eefa;
`;
